import { createContext, useContext } from 'react';

export const READ_STORAGE_KEY = 'gftg.read-announcements';

/**
 * PROVISIONAL, like the stars: ANN-03 wants an unread indicator, and `announcement_reads` is a table
 * keyed by person. The session that says which person now exists, so the objection this was waiting
 * on is gone — what is left is the write endpoint itself. Until it lands the marks stay on this
 * device, and the components only ever see `isRead` and `markRead`.
 */
export interface ReadAnnouncementsValue {
  isRead: (id: string) => boolean;
  /** Called with everything on screen once it has been seen, so the dots clear together. */
  markRead: (ids: readonly string[]) => void;
}

export const ReadAnnouncementsContext = createContext<ReadAnnouncementsValue | null>(null);

export function useReadAnnouncements(): ReadAnnouncementsValue {
  const value = useContext(ReadAnnouncementsContext);
  if (!value) {
    throw new Error('useReadAnnouncements must be used inside ReadAnnouncementsProvider');
  }
  return value;
}

export function readReadAnnouncements(): Set<string> {
  try {
    const raw = window.localStorage.getItem(READ_STORAGE_KEY);
    if (!raw) {
      return new Set();
    }
    const parsed: unknown = JSON.parse(raw);
    return new Set(
      Array.isArray(parsed)
        ? parsed.filter((item): item is string => typeof item === 'string')
        : [],
    );
  } catch {
    return new Set();
  }
}
